export const categoriesDisplayOptions = {
  data() {
    return {
      viewData: 'table',
      displayOptions: [
        {
          value: 'table',
          icon: 'table-large',
        },
        {
          value: 'pie',
          icon: 'chart-pie',
        },
      ],
    };
  },
};
